export default "__VITE_ASSET__BQOj1E47__"